var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isNewlyCreatedItem
    ? _c(
        "div",
        { staticClass: "w-full flex" },
        [
          _c(
            "Tooltip",
            {
              attrs: {
                title: _vm.tooltipTitle,
                variant: _vm.TooltipVariants.DARK,
                tooltipClasses: "w-60",
                placement: "top",
              },
            },
            [
              _vm.colorCode
                ? _c("ColorCodeTriangle", {
                    attrs: { colorCode: _vm.colorCode },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "flex items-center w-full p-4",
              class: _vm.avatarsPadding,
            },
            [
              _vm.contractor
                ? _c("SchedulerItemAvatar", {
                    staticClass: "mr-2",
                    attrs: {
                      avatar: _vm.contractorAvatar,
                      title: _vm.contractorName,
                    },
                  })
                : _vm._e(),
              _c("div", { staticClass: "flex truncate text-sm" }, [
                _c("span", { staticClass: "truncate text-white font-bold" }, [
                  _vm._v(_vm._s(_vm.activityName)),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "new-activity flex items-center" },
        [
          _c("span", { staticClass: "mr-4 text-white text-sm font-semibold" }, [
            _vm._v("New Task"),
          ]),
          _c("UiButton", {
            attrs: { buttonText: "Create", variant: "outline", size: "xxs" },
            on: {
              click: function ($event) {
                return _vm.$emit("create", _vm.activity)
              },
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }